export { default as EnNavbarSearch } from './EnNavbarSearch.vue';
export { default } from './EnNavbarSearch.vue';
